/*
 * @Author: fengjiahua fenjiahua@qq.com
 * @Date: 2025-03-17 14:21:38
 * @LastEditors: fengjiahua fenjiahua@qq.com
 * @LastEditTime: 2026-08-27 13:46:30
 * @FilePath: \qctsw-vue\packages\app\src\logic\complaint\column.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { usePagination } from '~/composables/usePagination'
import { getComplainTypeCode } from '~/pages/complaint/hooks/list'
import { complainResultPageApi, getComplaintAllApi, getComplaintCollectiveApi, getCompliantAllMoreApi } from '~/server'
import type { CollectiveComplainResponse, PrecinctComplainResponse } from '~/server/types'
import { isOnlyRouteQueryKeyChange, useGetRouteQuery } from '~/shared/function'

export function logicComplaintColumnAll() {
  const sub = useGetRouteQuery('sub', '0')
  const type = useGetRouteQuery('type', '0')
  const data = ref<PrecinctComplainResponse[]>([])
  const pagination = usePagination({
    type: 'pageNumber',
    key: '投诉栏目-全部/一追到底',
    pageSize: 20,
    request: (page, params: { complainTypeCode: number } = { complainTypeCode: 1 }) =>
      type.value === '4' && sub.value === '0'
        ? complainResultPageApi(page)
        : getComplaintAllApi({ ...page, ...params }),
  })

  async function getPage(page: number | string = 1, params: { complainTypeCode: number }) {
    const p = Number.isNaN(Number(page)) ? 1 : Number(page)

    // if (getComplainTypeCode(type.value, sub.value) != params.complainTypeCode)
    //   data.value = []
    if (p === 1)
      data.value = []
    const { list } = await pagination.loadPaginationData(p, params) || {}
    if (!list)
      return
    data.value.push(...list)
  }

  return {
    list: data,
    pagination,
    state: computed(() => pagination.pagination.status),
    getPage,
  }
}

export function logicComplaintColumnMore() {
  const data = ref<PrecinctComplainResponse[]>([])
  const pagination = usePagination({
    type: 'pageNumber',
    key: '投诉栏目-多次',
    pageSize: 20,
    request: (page, params: { complainTypeCode: number } = { complainTypeCode: 4 }) => getCompliantAllMoreApi({ ...page, ...params }),
  })

  async function getPage(page: number | string = 1, params: { complainTypeCode: number }) {
    const p = Number.isNaN(Number(page)) ? 1 : Number(page)
    if (p === 1)
      data.value = []
    const { list } = await pagination.loadPaginationData(p, params) || {}
    if (!list)
      return
    data.value.push(...list)
  }

  return {
    list: data,
    pagination,
    state: computed(() => pagination.pagination.status),
    getPage,
  }
}

export function logicComplaintColumnCollective() {
  const data = ref<CollectiveComplainResponse[]>([])
  const pagination = usePagination({
    type: 'pageNumber',
    key: '投诉栏目-集体',
    pageSize: 20,
    request: (page, params: { complainTypeCode: number } = { complainTypeCode: 1 }) => getComplaintCollectiveApi({ ...page, ...params }),
  })

  async function getPage(page: number | string = 1, params: { complainTypeCode: number }) {
    const p = Number.isNaN(Number(page)) ? 1 : Number(page)
    if (p === 1)
      data.value = []
    const { list } = await pagination.loadPaginationData(p, params) || {}
    if (!list)
      return
    data.value.push(...list)
  }

  return {
    list: data,
    pagination,
    state: computed(() => pagination.pagination.status),
    getPage,
  }
}
